export const app_enabled_disabled_en = {
  true: 'Enabled',
  false: 'Disabled',
};
